import styled from '@emotion/styled';

export const ItemsViewWrapper = styled.div`
    min-height: 40rem;
    display: list;
    grid-template-rows: auto 1fr auto;
    grid-template-columns: 100%;
`;
